// extracted by mini-css-extract-plugin
export default {"TncLink":"TermsOfUseDescription_TncLink__iexWB","BrightTncLink":"TermsOfUseDescription_BrightTncLink__VHOMp","DarkTncLink":"TermsOfUseDescription_DarkTncLink__iGi8W"};